import { Member } from '@/types/member';

/**
 * Génère un hook contextuel dynamique pour un membre
 * Priorité: Besoins actifs > Compétences rares > Nouveau membre > Expertise
 */
export const getContextualHook = (member: Member): string => {
  const roleText = member.role && member.company 
    ? `${member.role} @ ${member.company}`
    : member.role || '';

  // Règle 1 : Besoin actif (HOT LEAD) - différent du rôle
  if (member.needs && member.needs.length > 0) {
    return `🔥 Recherche : ${member.needs[0]}`;
  }
  
  // Règle 2 : Compétence rare/précieuse (VALEUR)
  const valuableSkills = ['Levée de fonds', 'Investment', 'M&A', 'IPO', 'Venture Capital'];
  const hasValuableSkill = member.skills?.find(skill => 
    valuableSkills.some(vs => skill.toLowerCase().includes(vs.toLowerCase()))
  );
  if (hasValuableSkill) {
    return `💰 Expert en : ${hasValuableSkill}`;
  }
  
  // Règle 3 : Bio
  if (member.bio && member.bio.trim().length > 0) {
    return member.bio.slice(0, 80) + (member.bio.length > 80 ? '...' : '');
  }
  
  // Fallback : Retourner chaîne vide pour éviter les doublons
  return '';
};

/**
 * Génère un CTA dynamique basé sur le contexte du membre
 */
export const getDynamicCTA = (
  member: Member, 
  currentUserType?: string,
  matchedSkillsCount: number = 0,
  mutualConnections: number = 0
): { text: string; icon: string } => {
  // Startup cherche investisseur
  if (member.type === 'investisseur' && currentUserType === 'startup') {
    return { text: 'Pitcher mon projet', icon: 'TrendingUp' };
  }
  
  // Investisseur cherche startup
  if (member.type === 'startup' && currentUserType === 'investisseur') {
    return { text: 'Découvrir le projet', icon: 'Eye' };
  }
  
  // Match sur compétences
  if (matchedSkillsCount > 0) {
    return { text: 'Proposer une collab', icon: 'Users' };
  }
  
  // Connexions mutuelles
  if (mutualConnections > 0) {
    return { text: 'Demander une intro', icon: 'UserCheck' };
  }
  
  // Membre actif recherchant quelque chose
  if (member.needs && member.needs.length > 0) {
    return { text: 'Je peux aider', icon: 'Check' };
  }
  
  // Default
  return { text: 'Se connecter', icon: 'Users' };
};
